module.exports = __webpack_public_path__ + "static/img/athlete2.c5f88bbc.svg";